<template>
  <div>
    <div class="return-record-info">
      <crm-button
        :buttonType="'plain'"
        size="mini"
        text="导出"
        class="fr mb10"
        :disabled="isExportDisabled"
        @click="handleExport"
      >
      </crm-button>
    </div>
    <el-table
      :data="dataList"
      :loading="loading"
      style="width: 100%; height: calc(100vh - 395px);"
    >
      <el-table-column prop="lx" label="类型" align="center"></el-table-column>
      <el-table-column prop="bzjyjyt" label="用途" align="center"></el-table-column>
      <el-table-column prop="je" label="金额" align="center"></el-table-column>
      <el-table-column prop="bz" label="备注" align="center"></el-table-column>
    </el-table>
    <div class="pageination">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="pageNumber"
        :page-sizes="[5, 10, 20]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next"
        :total="totalCount"
      >
      </el-pagination>
    </div>
  </div>
</template>

<script>
import CrmButton from "~component/base/crmButton";
import { mapActions } from 'vuex'
import config from '~config'
import { newDownloadByUrl } from '@/scripts/utils'

export default {
  components: {
    CrmButton,
  },
  filters: {},
  props: {
    id: String,
  },
  data() {
    return {
      dataList: [],
      loading: false,
      pageNumber: 1,
      pageSize: 10,
      totalCount: 0,
      isExportDisabled: false,
    }
  },
  computed: {},
  watch: {},
  methods: {
    ...mapActions({
      getInsideContractsBondList: 'compactInside/getInsideContractsBondList',
    }),
    // 点击tab发送请求
    queryList() {
      const param = {
        contractId: this.id,
        pageNumber: this.pageNumber,
        pageSize: this.pageSize,
      }
      this.getInsideContractsBondList(param).then(res => {
        this.dataList = res.results
        this.totalCount = res.totalCount
        this.pageNumber = res.pageNumber
        this.pageSize = res.pageSize
      }).catch(e => {
        console.log(e)
      })
    },
    handleSizeChange(value) {
      this.pageSize = value
      this.queryList()
    },
    handleCurrentChange(value) {
      this.pageNumber = value
      this.queryList()
    },
    handleExport() {
      this.isExportDisabled = true;
      this.notify = this.$notify({
        iconClass: "el-icon-loading",
        title: "",
        message: "正在导出中，请稍后...",
        duration: 0,
        showClose: false,
      });
      const params = {
        contractId: this.id,
        pageNumber: this.pageNumber,
        pageSize: this.pageSize,
      };
      const url = `${config.api || ""}/api/crmcontract/download/contractsBond`;
      newDownloadByUrl(url, "post", params).finally(() => {
        this.isExportDisabled = false;
        this.notify.close();
      });
    },
  },
}
</script>
